import React from 'react';
import { ROUTE_NAMES } from '../../Routes';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

import P_1 from '../../assets/press/Press-1-1.png';
import P_2 from '../../assets/press/Press-2-1.webp';
import P_3 from '../../assets/press/Press-3-1.jpg';
import P_12_1 from '../../assets/press/Press-12-1.webp';

const pressList = [
	{
		image: P_1,
		title:
			'Starlife: Construction Starts on ’21 Hollywood’ at 2100 N. Federal Highway, Hollywood, FL, 33020',
		link: ROUTE_NAMES.PRESS1,
	},
	{
		image: P_2,
		title:
			'21 Hollywood, a new 13-story mixed-use apartment development is coming to the heart of Hollywood',
		link: ROUTE_NAMES.PRESS2,
	},
	{
		image: P_3,
		title:
			'Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized as the Best in Luxury Real Estate',
		link: ROUTE_NAMES.PRESS3,
	},
];

export default function PressPage12() {
	const location = useLocation();
	const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

	return (
		<div className='press-single-page'>
			<Helmet>
				<title>
					Starlife Group Honored as a Winner in First Season of the 2025 TITAN
					Property Awards for 21 Hollywood Development
				</title>
				<meta
					name='description'
					content='The TITAN Property Awards has announced the winners of its first season in 2025.'
				/>
				<meta
					name='keywords'
					content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
				/>
				<link rel='canonical' href={canonicalUrl} />
			</Helmet>
			<div className='col-1'>
				<img src={P_12_1} alt='press-image' />
				<h1 className='press-page-title'>
					Starlife Group Honored as a Winner in First Season of the 2025 TITAN
					Property Awards for 21 Hollywood Development
				</h1>
				<span className='author-name'>By Apnews</span>
				<span className='author-name'>June 11, 2025</span>
				<Link
					to={
						'https://apnews.com/press-release/ein-presswire-newsmatics/starlife-group-honored-as-a-winner-in-first-season-of-the-2025-titan-property-awards-for-21-hollywood-development-1f102137e1b196b9203d79abde5cd662'
					}
				>
					<span className='author-name'>Source</span>
				</Link>

				<div className='press-page-content'>
					<p>
						<i>
							The TITAN Property Awards has announced the winners of its first
							season in 2025.
						</i>
					</p>
					<p>
						<i>
							“Starlife Group’s groundbreaking project set new benchmarks in the
							industry, shaping the future of architecture and interior spaces
							worldwide.”— Thomas Brandt, Spokesperson of IAA
						</i>
					</p>
					<p>
						NEW YORK, NY, UNITED STATES, June 11, 2025 / EINPresswire.com / --
						The TITAN Property Awards has announced the winners of its first
						season in 2025, honoring architects, developers, designers, and real
						estate professionals for their brilliance in the built environment
						worldwide. This year’s competition received over 1,000 entries from
						over 30 countries, reflecting the growing international
						participation and the diverse range of projects shaping today’s
						cities, communities, and living spaces. Among this season’s winners
						is Starlife Group, recognized for its transformative development, 21
						Hollywood, located in South Florida.
					</p>
					<p>
						Founded by visionary leader Gevorg Shahbazyan, Starlife Group has
						grown into a fully integrated real estate powerhouse with operations
						spanning development, construction, sales, capital ventures,
						lending, and brokerage. Based in Miami, the firm manages a diverse
						portfolio that includes luxury multifamily residences, mixed-use
						complexes, spec homes, and commercial properties across South
						Florida and Europe.
					</p>
					<p>
						Their award-winning project, 21 Hollywood, is a 14-story, 200-unit
						luxury rental and mixed-use development poised to redefine the
						Hollywood and Miami skyline. Located minutes from the Atlantic Ocean
						and Fort Lauderdale-Hollywood International Airport, the development
						is a collaboration with globally renowned architect Kobi Karp. The
						project also features 10,000 square feet of prime commercial space
						and combines California-inspired lifestyle aesthetics with Miami’s
						dynamic energy.
					</p>
					<p>
						More than a residential building, 21 Hollywood delivers a curated
						lifestyle experience, offering residents spaces to work, relax, and
						connect. The project is also part of the EB-5 investment program,
						allowing qualified foreign investors the opportunity to participate
						in a high-impact development while pursuing U.S. residency.
					</p>
					<p>
						Built with sustainability in mind, the development incorporates
						eco-conscious materials and natural design elements, blending
						environmental responsibility with modern luxury. With this project,
						Starlife Group has set a new benchmark for future-facing development
						in South Florida.
					</p>
					<p>Evaluation Process</p>
					<p>
						Submissions for the TITAN Property Awards undergo a blind judging
						process, reviewed by a panel of international experts across
						architecture, development, and design. Each entry is evaluated
						solely on its own merits, ensuring a fair and unbiased evaluation.
						21 Hollywood stood out for its design strategy, integration of
						services, and its contribution to both the local skyline and the
						international investment landscape.
					</p>
					<p>
						Notable Achievement in the 2025 TITAN Property Awards: Season 1:
					</p>
					<p>
						<ol>
							<li>Property Development - Apartment / Condominium</li>
							<li>Property Development - Mixed-Use Developments</li>
						</ol>
					</p>
					<p>
						“This season’s winners have demonstrated exceptional creativity,
						seamlessly blending functionality with aesthetics to craft
						transformative environments that inspire and elevate everyday
						living,” said Thomas Brandt, spokesperson of IAA. " Starlife Group’s
						groundbreaking project set new benchmarks in the industry, shaping
						the future of architecture and interior spaces worldwide. At IAA, we
						are proud to honor them as a luxury property leader who continue to
						push the boundaries of excellence.”
					</p>
					<p>
						For further information, please contact Starlife Group at
						info@thestarlifegroup.com, or visit:{' '}
						<a href='https://www.thestarlifegroup.com'>
							www.thestarlifegroup.com
						</a>
						.
					</p>
					<p>About Starlife Group</p>
					<p>
						Starlife Group is a real estate development and investment firm
						based in Miami, Florida, delivering integrated services across
						development, construction, capital, brokerage, mortgage, and
						lending. With a portfolio that includes high-end multifamily
						residences, mixed-use projects, commercial properties, and spec
						homes, the firm operates in both South Florida and Europe. Committed
						to transforming communities through innovation, sustainability, and
						design, Starlife Group is recognized for its strategic execution and
						forward-thinking approach to real estate.
					</p>
				</div>
			</div>
			<div className='col-2'>
				<div className='sticky-press-list'>
					<h3>Press Articles</h3>
					{pressList.map((item, idx) => (
						<Link to={item.link} key={idx}>
							<div className='other-press-card'>
								<img src={item.image} alt={`press-${idx}`} />
								<p>{item.title}</p>
							</div>
						</Link>
					))}
					<Link to={ROUTE_NAMES.PRESS}>
						<button className='view-all-press-btn'>View All</button>
					</Link>
				</div>
			</div>
		</div>
	);
}
